import React from 'react';
import classNames from 'classnames/bind';
import { Tabs } from '@beef/ui-kit';

import { Skeleton } from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const tabsArray = [
  {
    id: 'debit',
    title: 'Списания',
  },
  {
    id: 'replenish',
    title: 'Пополнения',
  },
];

export const SkeletonAccumulator = () => (
  <div className={cx('wrapper')}>
    <div className={cx('controls')}>
      <Tabs
        onChange={() => null}
        tabs={tabsArray}
        variant="secondary"
        selectedTab={tabsArray[0].id}
      />
      <Skeleton className={cx('sum')} />
    </div>
    <div className={cx('option-wrapper')}>
      {Array.from(
        Array(3).keys(),
      ).map((skeleton) => (
        <Skeleton
          key={skeleton}
        />
      ))}
    </div>
    <Skeleton className={cx('more-options')} />
  </div>
);
